import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import Cube from 'cube-ui'
import moment from 'moment'
import VueLazyload from 'vue-lazyload'
import i18n from './i18n'
import { Dialog } from 'vant'

// import FastClick from 'fastclick'
// // 使用
// FastClick.attach(document.body)

Vue.config.productionTip = false

Vue.filter('formatTime', val => {
    if (!val) {
        return ''
    } else {
        const duration = moment.duration(val, 'ms')
        const hours = duration.hours()
        const minutes = duration.minutes()
        console.log(duration, hours, minutes)
        let str = ''
        if (hours > 0) {
            str += `${hours}小时`
        }
        if (minutes > 0 && hours === 0) {
            str += `${minutes}分钟`
        } else if (minutes > 0) {
            str += `${minutes}分`
        }
        return str
    }
})

Vue.filter('formatDistance', val => {
    if (val < 1000) {
        return `${Math.round(val)}米`
    } else {
        const km = Math.round(parseInt(val * 10) / 1000) / 10
        return `${km}千米`
    }
})

Vue.filter('formatArrival', val => {
    const start = moment().add(val, 'ms')
    const end = moment().add(val, 'ms').add(3, 'm')
    return `${start.format('HH:mmA')} - ${end.format('HH:mmA')}`
})

router.beforeEach((to, from, next) => {
  console.log(from.query.language, to.query.language,22222)
  const siteId = to.query.siteId || '1'
  console.log('siteId--------', siteId)
  store.commit('SET_SITEID', siteId)
  if(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)){
    store.commit('SET_SAFARI', true)
  } else{
    store.commit('SET_SAFARI', false)
  }


  if(from.query.language) to.query['language'] = from.query.language
  if (to.query.language === 'zh') {
    i18n.locale = 'zh'
  } else {
    i18n.locale = 'en'
  }

  next()




})

Vue.use(VueLazyload, {
  error: '/image/default_img.jpg',
  loading: '/image/loading-img.jpg',
  attempt: 2
})
Vue.use(Cube)
// 全局注册
Vue.use(Dialog)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (process.env.NODE_ENV === 'development') {
    import('vconsole').then(VConsole => {
        new VConsole.default()
    })
}
